<template>
  <div>
    <div class="header">
      <div class="container-fluid">

        <b-row class="align-items-center mt-3 mb-2">
          <b-col>
            <span class="text-muted" v-if="empresasFiltradas.length !== empresas.length">
              {{ empresasFiltradas.length }} / {{ empresas.length }} {{ $t('clientes') }}
            </span>
            <span class="text-muted" v-else>{{ empresas.length }} {{ $t('clientes') }}</span>
          </b-col>
          <b-col class="text-right" v-if="puedeEscribir && (rol === 'admin' || rol === 'ventas inex')">
            <router-link :to="{ name: 'empresa-crear' }">
              <b-button variant="primary" size="sm">
                <i class="ni ni-fat-add mr-1"></i> {{ $t('crear_cliente') }}
              </b-button>
            </router-link>
          </b-col>
        </b-row>

        <b-alert variant="danger" :show="!!error" dismissible @dismissed="error = ''">
          {{ error }}
        </b-alert>

        <div v-if="cargando" class="text-center text-muted mt-5">
          <b-spinner variant="primary" />
        </div>

        <div v-else-if="empresas.length" class="card shadow" style="margin-bottom: 60px;">
          <div class="tabla-scroll-fixed" ref="tablaEmpresas">
            <table class="table table-hover align-items-center mb-0">
              <thead class="thead-sticky thead-light">
                <tr>
                  <th class="th-ordenable" style="width:60px;max-width:60px;" @click="ordenarPor('id')">
                    <input class="th-search-input" v-model="filterCol.id" @click.stop placeholder="Filtrar…" />
                    <span class="th-label">{{ $t('id') }} <i :class="iconoOrden('id')"></i></span>
                  </th>
                  <th class="th-ordenable" style="min-width:160px;" @click="ordenarPor('nombre')">
                    <input class="th-search-input" v-model="filterCol.nombre" @click.stop :placeholder="$t('buscar')" />
                    <span class="th-label">{{ $t('nombre') }} <i :class="iconoOrden('nombre')"></i></span>
                  </th>
                  <th class="th-ordenable" style="min-width:160px;" @click="ordenarPor('nombreFantasia')">
                    <input class="th-search-input" v-model="filterCol.nombreFantasia" @click.stop :placeholder="$t('buscar')" />
                    <span class="th-label">{{ $t('nombre_fantasia') }} <i :class="iconoOrden('nombreFantasia')"></i></span>
                  </th>
                  <th class="th-ordenable" @click="ordenarPor('rut')">
                    <input class="th-search-input" v-model="filterCol.rut" @click.stop :placeholder="$t('buscar')" />
                    <span class="th-label">{{ $t('rut') }} <i :class="iconoOrden('rut')"></i></span>
                  </th>
                  <th class="th-ordenable" @click="ordenarPor('taxId')">
                    <input class="th-search-input" v-model="filterCol.taxId" @click.stop :placeholder="$t('buscar')" />
                    <span class="th-label">{{ $t('tax_id') }} <i :class="iconoOrden('taxId')"></i></span>
                  </th>
                  <th class="th-ordenable" style="width:120px;max-width:120px;" @click="ordenarPor('direccion')">
                    <input class="th-search-input" v-model="filterCol.direccion" @click.stop :placeholder="$t('buscar')" />
                    <span class="th-label">{{ $t('direccion') }} <i :class="iconoOrden('direccion')"></i></span>
                  </th>
                  <th class="th-ordenable" @click="ordenarPor('region')">
                    <input class="th-search-input" v-model="filterCol.region" @click.stop :placeholder="$t('buscar')" />
                    <span class="th-label">{{ $t('region') }} <i :class="iconoOrden('region')"></i></span>
                  </th>
                  <th class="th-ordenable" style="min-width:140px;" @click="ordenarPor('nombreHolding')">
                    <input class="th-search-input" v-model="filterCol.holding" @click.stop :placeholder="$t('buscar')" />
                    <span class="th-label">{{ $t('holding') }} <i :class="iconoOrden('nombreHolding')"></i></span>
                  </th>
                  <th class="th-ordenable" style="min-width:140px;" @click="ordenarPor('nombreKam')">
                    <input class="th-search-input" v-model="filterCol.kam" @click.stop :placeholder="$t('buscar')" />
                    <span class="th-label">{{ $t('kam') }} <i :class="iconoOrden('nombreKam')"></i></span>
                  </th>
                  <th style="width:160px;"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="e in empresasPaginadas" :key="e.id">
                  <td>{{ e.id }}</td>
                  <td>{{ e.nombre }}</td>
                  <td>{{ e.nombreFantasia || '-' }}</td>
                  <td>{{ e.rut }}</td>
                  <td>{{ e.taxId || '-' }}</td>
                  <td style="max-width:120px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;" :title="e.direccion">{{ e.direccion }}</td>
                  <td>{{ e.region }}</td>
                  <td>{{ e.nombreHolding }}</td>
                  <td>{{ e.nombreKam || '-' }}</td>
                  <td class="text-center">
                    <router-link :to="{ name: 'empresa-detalle', params: { id: e.id } }">
                      <b-button size="sm" variant="outline-primary" class="mr-1">
                        <i class="fas fa-pencil-alt"></i>
                      </b-button>
                    </router-link>
                    <!-- Los perfiles de solo lectura (ej. "visita") no eliminan: el
                         DELETE del backend exige la política EmpresaManagement. -->
                    <b-button v-if="puedeEscribir" size="sm" variant="outline-danger" @click="eliminarEmpresa(e.id)">
                      <i class="fas fa-trash"></i>
                    </b-button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="pagination-floating-bar" v-if="empresas.length">
          <div class="d-flex align-items-center">
            <label class="mr-2 mb-0 text-secondary" style="font-size:.85rem;">{{ $t('items_por_pagina') || 'Items / pág.' }}</label>
            <select v-model.number="pageSize" @change="currentPage = 1" class="form-control form-control-sm" style="width:70px;">
              <option :value="20">20</option>
              <option :value="50">50</option>
              <option :value="100">100</option>
              <option :value="999999">Todas</option>
            </select>
          </div>
          <div class="d-flex align-items-center" style="gap:12px;">
            <button class="btn btn-outline-secondary btn-sm" :disabled="currentPage === 1" @click="currentPage--">
              <i class="fas fa-arrow-left mr-1"></i> {{ $t('anterior') || 'Anterior' }}
            </button>
            <span style="font-weight:600;color:#6c757d;font-size:.9rem;">
              {{ $t('pagina') || 'Página' }} {{ currentPage }} {{ $t('de') || 'de' }} {{ totalPages }}
              <span class="text-muted ml-2" style="font-size:.8rem;">({{ empresasFiltradas.length }} {{ $t('resultados') || 'resultados' }})</span>
            </span>
            <button class="btn btn-outline-primary btn-sm" :disabled="currentPage >= totalPages" @click="currentPage++">
              {{ $t('siguiente') || 'Siguiente' }} <i class="fas fa-arrow-right ml-1"></i>
            </button>
          </div>
          <div class="d-flex align-items-center" style="gap:6px;">
            <button class="btn btn-sm btn-scroll-nav" @click="scrollTabla('left')"><i class="fas fa-chevron-left"></i></button>
            <button class="btn btn-sm btn-scroll-nav" @click="scrollTabla('right')"><i class="fas fa-chevron-right"></i></button>
            <button class="btn btn-sm btn-scroll-nav" @click="scrollTabla('top')"><i class="fas fa-chevron-up"></i></button>
            <button class="btn btn-sm btn-scroll-nav" @click="scrollTabla('bottom')"><i class="fas fa-chevron-down"></i></button>
          </div>
        </div>

        <div v-else-if="!cargando" class="text-center text-muted mt-5">
          <i class="fas fa-building fa-3x mb-3"></i>
          <p>{{ $t('sin_clientes') || 'No hay clientes' }}</p>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import empresaService from '@/api/empresaService';
import utilsService from '@/api/utilsService';
import Swal from 'sweetalert2';

export default {
  name: 'EmpresaView',
  data() {
    return {
      empresas: [],
      cargando: false,
      error: '',
      ordenColumna: null,
      ordenDireccion: 'asc',
      filterCol: {
        id: '',
        nombre: '',
        nombreFantasia: '',
        rut: '',
        taxId: '',
        direccion: '',
        region: '',
        holding: '',
        kam: '',
      },
      currentPage: 1,
      pageSize: 50,
    };
  },

  watch: {
    filterCol: { deep: true, handler() { this.currentPage = 1; } },
  },

  computed: {
    rol() {
      return utilsService.getRol();
    },
    empresasFiltradas() {
      const fc = this.filterCol;
      let lista = this.empresas;
      if (fc.id)       lista = lista.filter(e => String(e.id || '').includes(fc.id));
      if (fc.nombre)   lista = lista.filter(e => (e.nombre || '').toLowerCase().includes(fc.nombre.toLowerCase()));
      if (fc.nombreFantasia) lista = lista.filter(e => (e.nombreFantasia || '').toLowerCase().includes(fc.nombreFantasia.toLowerCase()));
      if (fc.rut)      lista = lista.filter(e => (e.rut || '').toLowerCase().includes(fc.rut.toLowerCase()));
      if (fc.taxId)    lista = lista.filter(e => (e.taxId || '').toLowerCase().includes(fc.taxId.toLowerCase()));
      if (fc.direccion)lista = lista.filter(e => (e.direccion || '').toLowerCase().includes(fc.direccion.toLowerCase()));
      if (fc.region)   lista = lista.filter(e => (e.region || '').toLowerCase().includes(fc.region.toLowerCase()));
      if (fc.holding)  lista = lista.filter(e => (e.nombreHolding || '').toLowerCase().includes(fc.holding.toLowerCase()));
      if (fc.kam)      lista = lista.filter(e => (e.nombreKam || '').toLowerCase().includes(fc.kam.toLowerCase()));
      return lista;
    },
    empresasOrdenadas() {
      if (!this.ordenColumna) return this.empresasFiltradas;
      const sorted = [...this.empresasFiltradas];
      sorted.sort((a, b) => {
        let vA = a[this.ordenColumna];
        let vB = b[this.ordenColumna];
        if (vA == null) vA = '';
        if (vB == null) vB = '';
        if (typeof vA === 'number' && typeof vB === 'number') return this.ordenDireccion === 'asc' ? vA - vB : vB - vA;
        vA = String(vA).toLowerCase();
        vB = String(vB).toLowerCase();
        if (vA < vB) return this.ordenDireccion === 'asc' ? -1 : 1;
        if (vA > vB) return this.ordenDireccion === 'asc' ? 1 : -1;
        return 0;
      });
      return sorted;
    },
    totalPages() {
      if (this.pageSize >= 999999) return 1;
      return Math.max(1, Math.ceil(this.empresasOrdenadas.length / this.pageSize));
    },
    empresasPaginadas() {
      if (this.pageSize >= 999999) return this.empresasOrdenadas;
      const start = (this.currentPage - 1) * this.pageSize;
      return this.empresasOrdenadas.slice(start, start + this.pageSize);
    },
  },

  mounted() {
    this.$store.dispatch('setSidebarCollapsed', false);
    this._scrollHandler = this._onWindowScroll.bind(this);
    window.addEventListener('scroll', this._scrollHandler, { passive: true });
    this.cargarEmpresas();
  },

  beforeDestroy() {
    this.$store.dispatch('setSidebarCollapsed', false);
    window.removeEventListener('scroll', this._scrollHandler);
  },

  methods: {
    async cargarEmpresas() {
      this.cargando = true;
      this.error = '';
      try {
        this.empresas = await empresaService.getAll(this.rol);
      } catch (e) {
        this.error = (e && e.response && e.response.data && e.response.data.message) || this.$t('error');
      } finally {
        this.cargando = false;
      }
    },

    eliminarEmpresa(id) {
      if (!this.puedeEscribir) return;
      Swal.fire({
        title: this.$t('esta_seguro'),
        text: this.$t('eliminar_empresa_texto'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('eliminar'),
        cancelButtonText: this.$t('cancelar'),
        confirmButtonColor: '#dc3545',
        cancelButtonColor: '#6c757d',
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            await empresaService.deleteBy(id);
            this.empresas = await empresaService.getAll(this.rol);
            Swal.fire({ text: this.$t('eliminado_correctamente'), icon: 'success', timer: 2000, showConfirmButton: false });
          } catch (err) {
            Swal.fire({ icon: 'error', title: 'Oops...', text: err.message || this.$t('error_desconocido') });
          }
        }
      });
    },

    ordenarPor(columna) {
      if (this.ordenColumna === columna) {
        this.ordenDireccion = this.ordenDireccion === 'asc' ? 'desc' : 'asc';
      } else {
        this.ordenColumna = columna;
        this.ordenDireccion = 'asc';
      }
      this.currentPage = 1;
    },

    iconoOrden(columna) {
      if (this.ordenColumna !== columna) return 'fas fa-sort text-muted';
      return this.ordenDireccion === 'asc' ? 'fas fa-sort-up' : 'fas fa-sort-down';
    },

    scrollTabla(dir) {
      const el = this.$refs.tablaEmpresas;
      const px = 300;
      if (dir === 'left')   el && el.scrollBy({ left: -px, behavior: 'smooth' });
      if (dir === 'right')  el && el.scrollBy({ left:  px, behavior: 'smooth' });
      if (dir === 'top')    window.scrollTo({ top: 0, behavior: 'smooth' });
      if (dir === 'bottom') window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
    },

    _onWindowScroll() {
      const cont = this.$refs.tablaEmpresas;
      if (!cont) return;
      const thead = cont.querySelector('thead.thead-sticky');
      if (!thead) return;
      const top = cont.getBoundingClientRect().top;
      thead.style.transform = top < 0 ? `translateY(${-top}px)` : '';
    },
  },
};
</script>

<style scoped>
.divisor {
  font-size: 16px;
  font-weight: 400;
  color: #fff;
  padding: 15px;
  background: #6172e9;
  border-radius: 10px;
}

.card {
  border-radius: 10px;
  overflow: hidden;
}

.tabla-scroll-fixed {
  overflow-x: auto;
  position: relative;
  font-size: 0.8rem;
}

.thead-sticky {
  position: relative;
  z-index: 2;
  background: #f8f9fa;
}

.th-ordenable {
  cursor: pointer;
  user-select: none;
  min-width: 90px;
  vertical-align: top;
  white-space: nowrap;
}
.th-ordenable:hover {
  background-color: #e9ecef !important;
}

.th-search-input {
  width: 100%;
  font-size: 11px;
  padding: 2px 4px;
  border: 1px solid #ced4da;
  border-radius: 3px;
  margin-bottom: 3px;
  display: block;
  font-weight: normal;
}

.th-label {
  display: block;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
}

.tabla-scroll-fixed .table th,
.tabla-scroll-fixed .table td {
  font-size: 12px;
}

.btn-scroll-nav {
  width: 32px;
  height: 32px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #ced4da;
  background: #f8f9fa;
  color: #495057;
  border-radius: 6px;
}
.btn-scroll-nav:hover {
  background: #e9ecef;
  border-color: #adb5bd;
}

.pagination-floating-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 500;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 24px;
  background: #fff;
  border-top: 1px solid #dee2e6;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.08);
}
</style>
